import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import type { AppRouteRecord } from '@/types/core';
import { requireEmployeeManagement } from '@/helpers/routeGuards';

export const employeeCreateRoute: AppRouteRecord = {
  beforeEnter: requireEmployeeManagement(),
  component: () => import('@/views/employee/EmployeeForm.vue'),
  name: RouteNames.Employee.Create,
  path: 'create',
};

export const employeeEditRoute: AppRouteRecord = {
  beforeEnter: requireEmployeeManagement(),
  component: () => import('@/views/employee/EmployeeForm.vue'),
  name: RouteNames.Employee.Edit,
  path: ':employeeId/edit',
};

export const employeeListRoute: AppRouteRecord = {
  beforeEnter: requireEmployeeManagement(),
  component: () => import('@/views/employee/EmployeeList.vue'),
  name: RouteNames.Employee.List,
  path: '',
};

export const employeeRoutes: AppRouteRecord = {
  beforeEnter: requireEmployeeManagement(),
  children: [
    //
    employeeEditRoute,
    employeeCreateRoute,
    employeeListRoute,
  ],
  meta: {
    icon: Icons.Employee,
  },
  path: '/employee',
};
